<script>
	
	import { onMount } from 'svelte';

	import { getBatch } from "../../api/Batch";

	import {MicrobiologyData, NutritionalData}  from "../../stores.js";

	export let id = null;

	var companyName = null;

	var batchData = null;

	var microbiologyInputs = null;
	var nutritionalInputs = null;

	var microbiologyArray = null;
	var nutritionalArray = null;

	// for mean dataType
	/*	
		values:
			-microbiology - value 0 
			-nutritional - value 1
		default value - microbiology value 0
	*/

	var meanDataSelected = 0;


	var numberOfSamples = 1;

	var sampleItemData = null;
	var sampleItemIndex = 0;

	var Samples = null;

	var pageNumber = 0;
	var samplesNavNumberOfItems = 5;


	//Sample slide variables
	var maxPageNumber = null;

	onMount( async () => {
		
		var user = localStorage.getItem('user');


		user =  JSON.parse(user);
		companyName = user.company;

		var userData = {
			Company: companyName,
			BatchID: id
		}

		var res = await getBatch(userData);

		

		if(res.status == 'valid'){
			

			batchData = res.batchData;
			// console.log(batchData);

			if(batchData.DataType == 'Mean'){

				microbiologyInputs = {};
				nutritionalInputs = {};

				microbiologyInputs = batchData.Samples[0].Microbiology;

				if(batchData.Samples[0].Nutritional){
					nutritionalInputs = batchData.Samples[0].Nutritional;	
				}
				
				numberOfSamples = batchData.NumberOfSamples;
				microbiologyArray = [];
				nutritionalArray = [];

				for(let i = 0 ; i < MicrobiologyData.length ; i++ ){

					for (const [key, value] of Object.entries(MicrobiologyData[i])) {
		  				
		  				microbiologyArray.push(value);  
					}

				}

				for(let i = 0 ; i < NutritionalData.length ; i++ ){

					for (const [key, value] of Object.entries(NutritionalData[i])) {
		  				
		  				nutritionalArray.push(value);
					}

				}
			}
			else if(batchData.DataType == 'Individual'){

				microbiologyInputs = {};
				nutritionalInputs = {};
				microbiologyArray = [];
				nutritionalArray = [];
				Samples = batchData.Samples;
				Samples = Samples.slice(0,samplesNavNumberOfItems);

				console.log('Samples',Samples);

				numberOfSamples = batchData.NumberOfSamples;
				calcTablePages(numberOfSamples);
				sampleItemData = batchData.Samples[sampleItemIndex];

				console.log('sampleItemData',sampleItemData);

				for(let i = 0 ; i < MicrobiologyData.length ; i++ ){

					for (const [key, value] of Object.entries(MicrobiologyData[i])) {
		  				
		  				microbiologyInputs[key] = value;
		  				microbiologyArray.push(value);  
					}

				}

				for(let i = 0 ; i < NutritionalData.length ; i++ ){

					for (const [key, value] of Object.entries(NutritionalData[i])) {
		  				
		  				nutritionalInputs[key] = value;
		  				nutritionalArray.push(value);
					}

				}

				
			}

			
			
		}
		else if(res.status == 'error'){
			alert('error');
		}
	});

	function sampleItemHandler(index,n) {
		
		sampleItemIndex = index;
		sampleItemData = {};	
		sampleItemData = batchData.Samples[sampleItemIndex];

		console.log("sampleItemData",sampleItemData);

		sampleItemData = sampleItemData;
		sampleItemIndex = sampleItemIndex;

		// alert('sample:' + n  + '\n' + 'sampleItemIndex: ' + sampleItemIndex );
			
	}

	function calcTablePages(totalSize){

		var aux = 0;
		var integerPart = 0;
		var decimalPart = 0;
		

		aux = totalSize/samplesNavNumberOfItems;

		integerPart = parseInt(aux);
		decimalPart = parseInt((aux % 1).toFixed(2).substring(2));
		

		if(decimalPart == 0 ){

			maxPageNumber = integerPart-1;

		}
		else{

			decimalPart = decimalPart/100;

			// lastPageEl = (decimalPart * (integerPart*rowsPerPage))/integerPart;

			// alert(lastPageEl);

			maxPageNumber = Math.ceil(aux)-1;



		}

	}


	function sampleNavActionBtnHandler(e){
		var id = e.target.id;

		if(id == 'next'){

			if(pageNumber != maxPageNumber){
				pageNumber++;

				var startIndex = samplesNavNumberOfItems * pageNumber;
				var endIndex = startIndex + samplesNavNumberOfItems;

				Samples = batchData.Samples.slice(startIndex,endIndex);	
			}
			else{

			}

			
		}
		else if(id == 'back'){


			if(pageNumber != 0 ){
				

				pageNumber--;


				var startIndex = samplesNavNumberOfItems * pageNumber;

				var endIndex = startIndex +samplesNavNumberOfItems;

				Samples = batchData.Samples.slice(startIndex,endIndex);
		
			}
			else{

			}

		}
	}

	function meanNavHandle(e){
		var id = e.target.id;
		console.log('id',typeof id);
		switch(id){
			//Microbiology
			case "0":{
				meanDataSelected = id;
				break;
			}
			//Nutritional
			case "1":{	
				console.log('nutritionalInputs',nutritionalInputs);
				console.log('batchData',batchData);

				if(batchData.Samples[0].Nutritional){
					
					meanDataSelected = id;
				}
				else{
					alert("No Physicochemical data for this batch.");
					
				}
				break;
			}
		}
		
	}

	var microIndividualTableHeader = [
		{
			title: "Bacteria"
		},
		{
			title: "Value"
		},
		{
			title: "Units"
		}
	];

	var microDetectionIndividualTableHeader = [
		{
			title: "Bacteria"
		},
		{
			title: "Detected"
		},
	]

	var nutriIndividualTableHeader = [
		{
			title: "Property"
		},
		{
			title: "Value"
		},
		{
			title: "Units"
		}
	];

	var microTableHeader = [
		{
			title: "Bacteria"
		},
		{
			title: "Mean"
		},
		{
			title: "Min"
		},
		{
			title: "Max"
		},
		{
			title: "Units"
		}
	];

	var nutriTableHeader = [
		{
			title: "Property"
		},
		{
			title: "Mean"
		},
		{
			title: "Standard deviation"
		},
		{
			title: "Units"
		}
	];

	var microDetectionTableHeader = [
		{
			title: "Bacteria"
		},
		{
			title: "Positive Samples"
		}
	];


</script>

<div class="batchFullDataContainer">
	
	<div class="generalDataContainer">

		<div class="topContainer">

			<div class="titleGeneralData">
				General Data
			</div>

		</div>

		<div class="midContainer generalData">
			{#if batchData != null}
				<div class="generalDataItem">
					<div class="generalDataLabel">
						Batch ID 	
					</div>

					<div class="generalDataValue textOrange">
						{batchData.BatchID}
					</div>
				</div>

				<div class="generalDataItem">
					<div class="generalDataLabel">
						Product 	
					</div>

					<div class="generalDataValue">
						{batchData.Product}
					</div>
				</div>


				<div class="generalDataItem">
					<div class="generalDataLabel">
						Batch Size 	
					</div>

					<div class="generalDataValue">
						{batchData.BatchSize}
					</div>
				</div>

				<div class="generalDataItem">
					<div class="generalDataLabel">
						Number of samples 	
					</div>

					<div class="generalDataValue">
						{batchData.NumberOfSamples}
					</div>
				</div>

				<div class="generalDataItem">
					<div class="generalDataLabel">
						Trial 	
					</div>

					<div class="generalDataValue">
						{batchData.Trial}
					</div>
				</div>

				<div class="generalDataItem">
					<div class="generalDataLabel">
						Production Date  	
					</div>

					<div class="generalDataValue">
						{batchData.ProductionDate}
					</div>
				</div>

				<div class="generalDataItem">
					<div class="generalDataLabel">
						Insertion Date  	
					</div>

					<div class="generalDataValue">
						{batchData.InsertionDate}
					</div>
				</div>
			{/if}

		</div>
		
	</div>

	<div class="samplesContainer">

		{#if batchData != null}

			{#if batchData.DataType == 'Mean'}<!-- For dataType == Mean -->

				<div class="topContainer">
					<div class="titleSamples">
						Mean Sample
					</div>

					<div class="sampleNav">

						{#if meanDataSelected == 0}
							<div class="sampleNavItem textOrange" id="0" on:click={(e)=> meanNavHandle(e)}>
								Microbiology
							</div>

							<div class="sampleNavItem sampleNavItemActive" id="1" on:click={(e)=> meanNavHandle(e)}>
								Nutritional
							</div>

						{:else if meanDataSelected == 1}
							<div class="sampleNavItem sampleNavItemActive" id="0" on:click={(e)=> meanNavHandle(e)}>
								Microbiology
							</div>

							<div class="sampleNavItem  textOrange" id="1" on:click={(e)=> meanNavHandle(e)}>
								Nutritional
							</div>
						{/if}
						
					</div>
				</div>
				<div class="midContainer samples">
						
					{#if meanDataSelected == 0}

						<div class="meanTableContainer">
							<div class="meanTableRow">
								{#each microTableHeader as header,index}
									<div class="meanTableRowItem">
										{header.title}
									</div>
								{/each}
							</div>

							<div class="scrollableRows">
							{#if microbiologyArray != null && microbiologyInputs != null }
								{#each microbiologyArray as input}
									{#if !input.options}
										<div class="meanTableRow">
											<div class="meanTableRowItem">{input.label}</div>
											{#if microbiologyInputs[input.key]}
												<div class="meanTableRowItem">{microbiologyInputs[input.key]}</div>
											{:else}
												
												<div class="meanTableRowItem">-</div>
											{/if}

											{#if microbiologyInputs[input.keyMin]}
												<div class="meanTableRowItem">{microbiologyInputs[input.keyMin]}</div>
											{:else}
												<div class="meanTableRowItem">-</div>
											{/if}

											{#if microbiologyInputs[input.keyMax]}
												<div class="meanTableRowItem">{microbiologyInputs[input.keyMax]}</div>
											{:else}
												<div class="meanTableRowItem">-</div>
											{/if}

											<div class="meanTableRowItem">{input.units}</div>

										</div>

									{/if}
								{/each}
							{/if}
							</div>
						</div>

						<div class="meanTableContainer">
							<div class="meanTableRow">
								{#each microDetectionTableHeader as header,index}
									<div class="meanTableRowItem">
										{header.title}
									</div>
								{/each}
							</div>


							{#if microbiologyArray != null && microbiologyInputs != null }
								{#each microbiologyArray as input}
									{#if input.options}
										<div class="meanTableRow">
											<div class="meanTableRowItem">{input.label}</div>
											<!-- {#if microbiologyInputs[input.key]}
												<input disabled bind:value={microbiologyInputs[input.key]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.key} placeholder={input.placeholder}>
											{:else}
												<input disabled value="-" class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.key} placeholder={input.placeholder}>
											{/if} -->
											<div class="meanTableRowItem">{microbiologyInputs[input.key]?? '-' }</div>
										</div>

									{/if}
								{/each}
							{/if}
						</div>

					{:else if meanDataSelected == 1}
						<div class="meanTableContainer">
							<div class="meanTableRow">
								{#each nutriTableHeader as header,index}
									<div class="meanTableRowItem">
										{header.title}
									</div>
								{/each}
							</div>

							<div class="scrollableRows">
							{#if nutritionalArray != null && nutritionalInputs != null}
								{#each nutritionalArray as input}
									{#if input.type != 'dummy'}
										<div class="meanTableRow">
											<div class="meanTableRowItem ">{input.label}</div>

											{#if nutritionalInputs[input.key]}
												<div class="meanTableRowItem">{nutritionalInputs[input.key]}</div>
											{:else}
												<div class="meanTableRowItem">-</div>
											{/if}


											{#if nutritionalInputs[input.keyStd]}
												<div class="meanTableRowItem">{nutritionalInputs[input.keyStd]}</div>
											{:else}
												<div class="meanTableRowItem">-</div>
											{/if}

											<div class="meanTableRowItem">{input.units}</div>

										</div>

									{/if}
								{/each}
							{/if}
							</div>
						</div>
					{/if}
						
					
				</div>

			{:else if batchData.DataType == 'Individual'} <!-- For dataType == Indivudual -->
				<div class="topContainer">
					<div class="titleSamples">
						Samples
					</div>

					<div class="sampleNavContainer">
						
						<div class="sampleNav">
							{#if batchData != null && Samples != null}
								{#each Samples as sample,index}

									{#if sampleItemIndex == (index + (pageNumber*samplesNavNumberOfItems))}

										<div class=" sampleNavItem textOrange"  on:click={() => sampleItemHandler(sample.SampleID-1,index)}>
											Sample {sample.SampleID}
										</div>
									{:else}
										<div class=" sampleNavItem sampleNavItemInactive"  on:click={() => sampleItemHandler(sample.SampleID-1,index)}>
											Sample {sample.SampleID}
										</div>

									{/if}
								{/each}
							{/if}
						</div>

						<div class="sampleNavActionBtns">

							<div class="pagesBtnContainer">

								{#if numberOfSamples > 5}
									<div class="pagesBtn" id="back" on:click={(e) => sampleNavActionBtnHandler(e)}>
										 &lt;
									</div>

									<div class="pagesBtn" id="next" on:click={(e) => sampleNavActionBtnHandler(e)}>
										&gt;
									</div>
								{:else}
									<div class="pagesBtn" id="back">
										 
									</div>

									<div class="pagesBtn" id="next">
										
									</div>
								{/if}
								

							</div>
						</div>

					</div>
				</div>

				<div class="midContainer samplesIndividual">
					<div class="samplesTop">
						{#if meanDataSelected == 0}
							<div class="sampleNavItem textOrange" id="0" on:click={(e)=> meanNavHandle(e)}>
								Microbiology
							</div>

							<div class="sampleNavItem sampleNavItemActive" id="1" on:click={(e)=> meanNavHandle(e)}>
								Nutritional
							</div>

						{:else if meanDataSelected == 1}
							<div class="sampleNavItem sampleNavItemActive" id="0" on:click={(e)=> meanNavHandle(e)}>
								Microbiology
							</div>

							<div class="sampleNavItem  textOrange" id="1" on:click={(e)=> meanNavHandle(e)}>
								Nutritional
							</div>
						{/if}
					</div>

					<div class="sampleItemContainer">
						{#if meanDataSelected == 0}
							<div class="meanTableContainer">
								<div class="meanTableRow">
									{#each microIndividualTableHeader as header,index}
										<div class="meanTableRowItem">
											{header.title}
										</div>
									{/each}
								</div>

								<div class="scrollableRows">
								{#if sampleItemData != null && microbiologyArray != null && microbiologyInputs != null }
									{#each microbiologyArray as input}
										{#if !input.options}
											<div class="meanTableRow">
												<div class="meanTableRowItem">{input.label}</div>
												{#if sampleItemData.Microbiology[input.key]}
													<div class="meanTableRowItem">{sampleItemData.Microbiology[input.key]}</div>
												{:else}
													
													<div class="meanTableRowItem">-</div>
												{/if}
												<div class="meanTableRowItem">{input.units}</div>
											</div>

										{/if}
									{/each}
								{/if}
								</div>
							</div>
							<div class="meanTableContainer">
								<div class="meanTableRow">
									{#each microDetectionIndividualTableHeader as header,index}
										<div class="meanTableRowItem">
											{header.title}
										</div>
									{/each}
								</div>

								{#if sampleItemData != null && microbiologyArray != null && microbiologyInputs != null }
									{#each microbiologyArray as input}
										{#if input.options}
											<div class="meanTableRow">
												<div class="meanTableRowItem">{input.label}</div>
												<div class="meanTableRowItem">{sampleItemData.Microbiology[input.key]?? '-' }</div>
											</div>

										{/if}
									{/each}
								{/if}
							</div>
						{:else if meanDataSelected == 1}

							<div class="meanTableContainer">
								<div class="meanTableRow">
									{#each nutriIndividualTableHeader as header,index}
										<div class="meanTableRowItem">
											{header.title}
										</div>
									{/each}
								</div>
								<div class="scrollableRows">
								{#if sampleItemData != null && nutritionalArray != null && nutritionalInputs != null }
									{#each nutritionalArray as input}
										{#if !input.options}
											<div class="meanTableRow">
												<div class="meanTableRowItem">{input.label}</div>
												{#if sampleItemData.Nutritional[input.key]}
													<div class="meanTableRowItem">{sampleItemData.Nutritional[input.key]}</div>
												{:else}
													
													<div class="meanTableRowItem">-</div>
												{/if}
												<div class="meanTableRowItem">{input.units}</div>
											</div>

										{/if}
									{/each}
								{/if}
								</div>
							</div>
						{/if}	
					</div>
				</div>
			{/if}
		{/if}
		
		

	</div>

</div>



<style>

	/*******************/
	.meanTableContainer{
		/*width: 100%;*/
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-0.6925207756232687vh);
		border-radius: 0.3255208333333333vw;
		flex-grow: 1;

	}
	/*.microbiologyContainer > .meanTableContainer, .nutritionalContainer > .meanTableContainer {
		width: 100% !important;
		height: 50% !important;
	}*/


	.samples > .meanTableContainer:nth-of-type(1), .sampleItemContainer > .meanTableContainer:nth-of-type(1){
		width:70%;
		max-height: 600px;
	}



	.scrollableRows{
		width: 100%;
		overflow-y: scroll;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.samples > .meanTableContainer:nth-of-type(2), .sampleItemContainer > .meanTableContainer:nth-of-type(2){
		width:25%;
		height: max-content;
	}

	.meanTableRow{
		width: 95%;
		height: 8.8%;
		min-height: 5.2631578947368425vh;
		display: flex;
		flex-direction: row;
		background-color: transparent;
		border-bottom-color: white;
		border-bottom-width:  0.06510416666666667vw;
		border-bottom-style: solid;
	}

	.meanTableRow:nth-child(even){
		background-color: rgba(33, 153, 255, 0.2);
	}


	.meanTableRowItem{
		width: 25%;
		height: 5.2631578947368425vh;
		color: black;
		display: flex;
		align-items: center;
		font-size: 0.8463541666666666vw;
		font-weight: 700;
		/*opacity: 0.8;*/
		flex-grow: 1;
	}

	.meanTableRowItem:not(:nth-child(1)){
		justify-content: center;
	}
	/*.meanTableRowItem:nth-child(5){
		justify-content: center;	
	}*/

	.tableInputText{
		/*height: 90%;*/
		height: 5.2631578947368425vh;
		background-color: transparent;
		color: black;
		border: none;
		outline: none;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.tableInputText:focus{
		outline: none;
	}

	
	

	.tableInputSelect{      
		-webkit-appearance: auto;
		-moz-appearance: auto;
		background-color: transparent;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		border: none;
	}



	.tableInputSelectOption{
		width: 100%;
		/*height: 33.333333%;*/
		height: 5.2631578947368425vh;
		background-color: transparent;
		border:  0.06510416666666667vw solid white;
		border-radius: 0px;
		color: black;
		font-size: 0.9114583333333334vw;
		font-weight: 700;

	}
	/******************/




	.batchFullDataContainer{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		background-color: white;
		gap: 2%;

	}

	.generalDataContainer{
		width: 30%;
		height: 100%;
		display: flex;
		flex-direction: column;
		
	}

	.samplesContainer{
		width: 58%;
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.topContainer{
		width: 100%;
		height: 10%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.titleGeneralData{
		width: 90%;
		height: fit-content;
		font-size: 1.3020833333333333vw;
		font-weight: 700;
		color: black;
		opacity: 0.8;
		
		
	}

	.titleSamples{
		width: 20%;
		height: fit-content;
		font-size: 1.3020833333333333vw;
		font-weight: 700;
		color: black;
		opacity: 0.8;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
	}



	.midContainer{
		width: 100%;
		height: 80%;
		/*background-color: orange;*/
		border-radius: 3px;
		

	}

	.generalData{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
	}

	.generalDataItem{
		width: 90%;
		height: 10%;
		display: flex;
		flex-direction: row;
		margin-top: 2%;
	}

	.generalDataLabel{
		width: 60%;
		height: 100%;
		color:  black;
		font-size: 1.0416666666666667vw;
		font-weight: 900;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

 	.generalDataValue{
		width: 40%;
		height: 100%;
		color:  black;
		font-size: 1.0416666666666667vw;
		font-weight: 900;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.samples{
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		gap: 2%;
	}

	.samplesIndividual{
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;	
	}

	.samplesTop{
		width: 100%;
		height: 10%;
		display: flex;
		justify-content: flex-start;
	}



	.sampleItemContainer{
		width: 100%;
		height: 90%;
		display: flex;
		flex-direction: row;
		gap: 2%;
	}


	.microbiologyContainer,.nutritionalContainer{
		width: 50%;
		height: 90%;
		display: flex;
		flex-direction: column;
	}


	.sampleTitle{
		width: 100%;
		height: 10%;
		flex-shrink: 0;
		flex-grow: 0;
		/*background-color: yellow;*/
		color:  black;
		font-size: 1.171875vw;
		font-weight: 700;
		margin-top: 2%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		opacity: 0.8;


	}

	.sampleNavContainer{
		width: 81%;
		height: 50%;
		/*background-color: yellow;*/
		display: flex;
		flex-direction: row;
	}

	.sampleNav{
		width: 90%;
		height: 100%;
		/*background-color: green;*/
		display: flex;
		flex-direction: row;
	}

	.sampleNavItem{
		width: 20%;
		height: 100%;
		color:  black;
		font-size: 1.171875vw;
		font-weight: 900;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
	}
	.sampleNavItem:hover{
	}

	.sampleNavItemActive{
		opacity: 1;
	}

	.sampleNavItemInactive{
		opacity: 0.8;
	}

	.sampleNavActionBtns{
		width: 10%;
		height: 100%;
	}

	.pagesBtnContainer{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: row;
	}

	.pagesBtn{
		width: 50%;
		height: 100%;
		color: black;
		opacity: 0.8;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}


	.textOrange{
		color: #FFAE6A;
	}

</style>